import type { CSSProperties } from "react";
import { cn } from "../utils/cn";

const iconUrl = new URL(
  "../assets/icons/mcp-default-figma.svg",
  import.meta.url,
).href;

type Props = {
  className?: string;
  style?: CSSProperties;
};

export const McpDefaultIcon = ({ className, style }: Props) => {
  const mask = `url("${iconUrl}") center / contain no-repeat`;

  return (
    <span
      aria-hidden="true"
      className={cn("inline-block shrink-0 bg-current", className)}
      style={{ ...style, mask, WebkitMask: mask }}
    />
  );
};
